module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-battery-detail/master-battery-detail.component.scss
// module id = ./src/app/master/master-battery-detail/master-battery-detail.component.scss
// module chunks = main